(function () {
  function initFlavors(viewport) {
    const slides = Array.prototype.slice.call(viewport.querySelectorAll('.pf-flavors__slide'));
    const dots = Array.prototype.slice.call(viewport.querySelectorAll('.pf-flavors__dot'));
    const prev = viewport.querySelector('.pf-flavors__arrow--prev');
    const next = viewport.querySelector('.pf-flavors__arrow--next');
    const count = slides.length;
    if (count === 0) return;

    let active = parseInt(viewport.getAttribute('data-active'), 10) || 0;

    function render() {
      slides.forEach(function (slide) {
        const i = parseInt(slide.getAttribute('data-index'), 10);
        const diff = (i - active + count) % count;
        slide.classList.remove('is-center', 'is-left', 'is-right');
        if (diff === 0) {
          slide.classList.add('is-center');
        } else if (diff === count - 1) {
          slide.classList.add('is-left');
        } else {
          slide.classList.add('is-right');
        }
      });

      dots.forEach(function (dot, i) {
        const on = i === active;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      viewport.setAttribute('data-active', active);
    }

    function go(to) {
      active = (to + count) % count;
      render();
    }

    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    render();
  }

  document.querySelectorAll('.pf-flavors__viewport').forEach(initFlavors);

  document.addEventListener('shopify:section:load', function (e) {
    const viewport = e.target.querySelector('.pf-flavors__viewport');
    if (viewport) initFlavors(viewport);
  });

  document.addEventListener('shopify:block:select', function (e) {
    const slide = e.target.closest('.pf-flavors__slide');
    const viewport = e.target.closest('.pf-flavors__viewport');
    if (!slide || !viewport) return;
    const idx = parseInt(slide.getAttribute('data-index'), 10);
    const dot = viewport.querySelector('.pf-flavors__dot[data-index="' + idx + '"]');
    if (dot) dot.click();
  });
})();
